module.exports = __webpack_public_path__ + "static/media/ahresp.c8c6ebde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ahresp.svg
// module id = 320
// module chunks = 0